import { IconButton, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import {
  Cancel,
  CheckCircle,
  Close,
  ReportProblemOutlined,
  WatchLater,
  Error,
  Description,
  MoreVert,
} from '@material-ui/icons';
import AttachFile from '@material-ui/icons/AttachFile';
import { useGenericStyles } from 'common/genericStyles';
import {
  InstrumentoFinanceiroApiResponse,
  CompraVendaStatus,
  OperacaoCommonStatus,
  OperacaoCompraVendaResponse,
  GrupoAcesso,
  OfertaPrimariaStatus,
  Perfil,
  OperacaoCompraVendaCompromissadaResponse,
  ComprasVendasFilter,
  CompraVendaResumoResponse,
  CompraVendaDocumento,
} from 'common/genericTypes';
import InfoIcon from '@material-ui/icons/Info';
import { Alert } from 'components/alert';
import { GenericDrawer } from 'components/genericDrawer';
import { GestaoComprovantesDrawer } from 'pages/operacoes/compraVenda/gestaoComprovantesDrawer';
import { MdSpace, MoreOptionsMenu, NumberField, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { addCpfCnpjMask } from 'utils/mask';
import { formatEightDecimalsCurrency } from 'utils/number';
import LegendaStatus from './legendaStatus';
import {
  DataGridPro,
  getGridDateOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
  GridCellParams,
  GridFilterModel,
  GridSortModel,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import { localizedTextsMap } from 'utils/dataGridUtils';
import { componentsPropsValues, rowsPerPageOptionsValues } from 'utils/dataGrid/dataGridUtils';
import CustomToolBarUtils from 'utils/dataGrid/customToolBar';
import { formatDate } from 'utils/date';
import { operacaoStatusDescriptions } from 'common/genericDescriptions';
import { formatInstrumentoCurrency } from 'utils/instrumentoFinanceiroUtils';
import { safeGet } from './comprasVendas';
import {
  descreverIdaOuVoltaDaCompromissada,
  deveExibirPrecoUnitarioCalculado,
  isPrecoUnitarioDeLiquidacaoInvalido,
  isRetornoDeCompromissada,
  podeConfirmarLiquidacaoDaCompromissada,
  resolverPrecoUnitarioDaLiquidacao,
  resolverPrecoUnitarioExibidoNaLiquidacao,
} from './liquidacaoRetornoCompromissada';
import {
  montarFiltroDeComprasVendasCompromissadas,
  opcoesDeFiltroIdaOuVoltaDaCompromissada,
} from './comprasVendasCompromissadasFiltros';
import { podeAprovarCompromissada } from './aprovacaoCompromissada';

enum DrawerAction {
  ACEITAR,
  REJEITAR,
  CONFIRMAR_LIQUIDACAO,
}

const ComprasVendasCompromissadas: React.FC = () => {
  const classes = useGenericStyles();
  const history = useHistory();

  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = React.useState(20);
  const [pageCount, setPageCount] = useState<number>(0);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [operacoes, setOperacoes] = useState<Array<CompraVendaResumoResponse>>([]);
  const [linkOperator, setLinkOperator] = useState<any>('AND');
  const [comprasVendasFilter, setComprasVendasFilter] = useState<Array<ComprasVendasFilter>>([]);

  const [operacao, setOperacao] = useState<OperacaoCompraVendaCompromissadaResponse>();
  const [openAprovarRejeitarDrawer, setOpenAprovarRejeitarDrawer] = useState<boolean>(false);
  const [openConfirmarLiquidacaoDrawer, setOpenConfirmarLiquidacaoDrawer] = useState<boolean>(false);
  const [instrumentoInadimplido, setInstrumentoInadimplido] = useState<boolean>(false);
  const [drawerAction, setDrawerAction] = useState<DrawerAction>(DrawerAction.ACEITAR);
  const [precoUnitarioLiquidacao, setPrecoUnitarioLiquidacao] = useState<number | undefined>(undefined);
  const [showStatusToast, setShowStatusToast] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const [openGestaoComprovantesDrawer, setOpenGestaoComprovantesDrawer] = useState<boolean>(false);
  const [comprovantesOperacaoId, setComprovantesOperacaoId] = useState<string | undefined>(undefined);
  const [comprovantesCodigoIF, setComprovantesCodigoIF] = useState<string | undefined>(undefined);
  const [compraVendaDocumentos, setCompraVendaDocumentos] = useState<Array<CompraVendaDocumento>>([]);

  const dispatch = useDispatch();

  const isUsuarioOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.Operacoes;
  const isUsuarioCadastroOperacoes =
    useSelector((state: RootState) => state.auth.usuario.grupoAcesso) === GrupoAcesso.CadastroOperacoes;
  const participanteId = useSelector((state: RootState) => state.auth.usuario.participante.id);
  const participanteRazaoSocial = useSelector((state: RootState) => state.auth.usuario.participante.razaoSocial);
  const getOperacaoCompraVendaDetalhes = useSelector(
    (state: RootState) => state.operacaoApi.getOperacaoCompraVendaDetalhes
  );
  const postComprasVendasCompromissadasPaginated = useSelector(
    (state: RootState) => state.operacaoApi.postComprasVendasCompromissadasPaginated
  );
  const postAceitarCompraVenda = useSelector((state: RootState) => state.operacaoApi.postAceitarCompraVenda);
  const postConfirmarLiquidacaoCompraVenda = useSelector(
    (state: RootState) => state.operacaoApi.postConfirmarLiquidacaoCompraVenda
  );
  const postRejeitarCompraVenda = useSelector((state: RootState) => state.operacaoApi.postRejeitarCompraVenda);
  const getInstrumentoDetalhes = useSelector((state: RootState) => state.instrumentoApi.getInstrumentoDetalhes);
  const getCompraVendaDocumentos = useSelector((state: RootState) => state.operacaoApi.getCompraVendaDocumentos);

  const handleOpenDrawer = async (action: DrawerAction, operacaoId: string) => {
    try {
      setShowStatusToast(false);
      setDrawerAction(action);
      setPrecoUnitarioLiquidacao(undefined);

      // ponytail: cast seguro — backend serializa CompraVendaCompromissadaResponse no mesmo endpoint
      const detalhes = await getOperacaoCompraVendaDetalhes(dispatch, operacaoId, true);
      setOperacao(detalhes as unknown as OperacaoCompraVendaCompromissadaResponse);
      setInstrumentoInadimplido(false);

      action === DrawerAction.CONFIRMAR_LIQUIDACAO
        ? setOpenConfirmarLiquidacaoDrawer(true)
        : setOpenAprovarRejeitarDrawer(true);
    } catch (error) {
      console.error('Falha ao carregar detalhes da operação compromissada:', error);
    }
  };

  const handleCloseDrawer = () => {
    drawerAction === DrawerAction.CONFIRMAR_LIQUIDACAO
      ? setOpenConfirmarLiquidacaoDrawer(false)
      : setOpenAprovarRejeitarDrawer(false);
    setOperacao(undefined);
    setPrecoUnitarioLiquidacao(undefined);
  };

  const isRetornoCompromissada = isRetornoDeCompromissada(operacao?.tipo);
  const precoUnitarioInformadoInvalido = isPrecoUnitarioDeLiquidacaoInvalido(precoUnitarioLiquidacao);

  const getOperacoes = useCallback(async () => {
    try {
      setShowLoader(true);
      const result = await postComprasVendasCompromissadasPaginated(
        dispatch,
        {
          page: page + 1,
          pageSize,
          linkOperator,
          comprasVendasFilter,
        },
        true
      );
      setOperacoes(result.result);
      setPageCount(result.totalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  }, [dispatch, postComprasVendasCompromissadasPaginated, page, pageSize, linkOperator, comprasVendasFilter]);

  const getInstrumento = useCallback(
    async (instrumentoId: string): Promise<InstrumentoFinanceiroApiResponse | null> => {
      try {
        const result = await getInstrumentoDetalhes(dispatch, instrumentoId);
        return result;
      } catch (error) {
        return null;
      }
    },
    [dispatch, getInstrumentoDetalhes]
  );

  const statusToastByAction = useCallback(
    (action: DrawerAction) => {
      let divClassName: string = '';
      let resultDescription: string = '';
      let icon: React.ReactNode = null;
      switch (action) {
        case DrawerAction.REJEITAR:
          divClassName = classes.errorToast;
          resultDescription = 'rejeitada';
          icon = <Cancel style={{ marginRight: 10 }} />;
          break;
        case DrawerAction.ACEITAR:
          divClassName = classes.successToast;
          resultDescription = 'aceita';
          icon = <CheckCircle style={{ marginRight: 10 }} />;
          break;
        case DrawerAction.CONFIRMAR_LIQUIDACAO:
          divClassName = classes.successToast;
          resultDescription = 'liquidada';
          icon = <CheckCircle style={{ marginRight: 10 }} />;
          break;
      }
      return (
        <>
          <SmSpace />
          <div className={divClassName}>
            {icon}
            <div style={{ display: 'flex', flex: 1 }}>
              <Typography variant="body2">{'Movimentação por'}</Typography>&nbsp;
              <Typography>{`Compra e Venda ${resultDescription}`}</Typography>
              &nbsp;
              <Typography variant="body2">{'com sucesso.'}</Typography>
            </div>
            <IconButton onClick={() => setShowStatusToast(false)}>
              <Close />
            </IconButton>
          </div>
        </>
      );
    },
    [classes]
  );

  const handleAceitar = async () => {
    try {
      if (operacao) {
        setSubmitting(true);
        await postAceitarCompraVenda(dispatch, operacao.id);
        await getOperacoes();
        handleCloseDrawer();
        setShowStatusToast(true);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  const handleConfirmarLiquidacao = async () => {
    try {
      if (operacao) {
        setSubmitting(true);
        await postConfirmarLiquidacaoCompraVenda(
          dispatch,
          operacao.id,
          resolverPrecoUnitarioDaLiquidacao(operacao.tipo, precoUnitarioLiquidacao)
        );
        await getOperacoes();
        handleCloseDrawer();
        setShowStatusToast(true);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  const handleRejeitar = async () => {
    try {
      if (operacao) {
        setSubmitting(true);
        await postRejeitarCompraVenda(dispatch, operacao.id, '');
        await getOperacoes();
        handleCloseDrawer();
        setShowStatusToast(true);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  const handleOpenGestaoComprovantes = async (item: CompraVendaResumoResponse) => {
    try {
      const docs = await getCompraVendaDocumentos(dispatch, item.operacaoId, true);
      setCompraVendaDocumentos(docs);
    } catch {
      setCompraVendaDocumentos([]);
    }
    setComprovantesOperacaoId(item.operacaoId);
    setComprovantesCodigoIF(item.codigo);
    setOpenGestaoComprovantesDrawer(true);
  };

  const handleCloseGestaoComprovantes = () => {
    setOpenGestaoComprovantesDrawer(false);
    setComprovantesOperacaoId(undefined);
    setComprovantesCodigoIF(undefined);
    setCompraVendaDocumentos([]);
  };

  const handleGestaoComprovantesUploadSuccess = async () => {
    if (comprovantesOperacaoId) {
      try {
        const docs = await getCompraVendaDocumentos(dispatch, comprovantesOperacaoId, true);
        setCompraVendaDocumentos(docs);
      } catch {
        setCompraVendaDocumentos([]);
      }
    }
    await getOperacoes();
  };

  const onFilterChange = useCallback((filterModel: GridFilterModel) => {
    if (!filterModel.items || filterModel.items.length === 0) {
      setComprasVendasFilter((prev) => (prev.length === 0 ? prev : []));
      setPage(0);
      return;
    }

    setLinkOperator(filterModel?.linkOperator?.toString()?.toUpperCase() ?? 'AND');

    const newComprasVendasFilter = new Array<ComprasVendasFilter>();
    filterModel.items.forEach((filter) => {
      const params = montarFiltroDeComprasVendasCompromissadas(filter);
      if (params) {
        newComprasVendasFilter.push(params);
      }
    });

    setComprasVendasFilter(newComprasVendasFilter);
    setPage(0);
  }, []);

  const onSortChange = useCallback(
    (sortModel: GridSortModel) => {
      const newComprasVendasFilter = comprasVendasFilter.filter(
        (x) => x.orderByType != 'ASC' && x.orderByType != 'DESC'
      ) as Array<ComprasVendasFilter>;

      if (sortModel.length === 0 || sortModel == null) {
        setComprasVendasFilter([...newComprasVendasFilter]);
        setPage(0);
        return;
      }

      const filter = sortModel[0];
      const params = {
        columnType: filter.field.toUpperCase(),
        orderByType: filter.sort?.toUpperCase(),
      } as ComprasVendasFilter;

      newComprasVendasFilter.push(params);
      setComprasVendasFilter([...newComprasVendasFilter]);
      setPage(0);
    },
    [comprasVendasFilter]
  );

  const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith', 'is'].includes(value)
  );

  const filterOperatorsSelect = getGridSingleSelectOperators().filter(({ value }) => ['is', 'not'].includes(value));

  const filterOperatorsData = getGridDateOperators().filter(({ value }) =>
    ['is', 'not', 'after', 'onOrAfter', 'before', 'onOrBefore'].includes(value)
  );

  const statusValueOptions = [
    ...Object.keys(OperacaoCommonStatus).map((key) => ({
      value: (OperacaoCommonStatus as any)[key],
      label: operacaoStatusDescriptions[(OperacaoCommonStatus as any)[key]],
    })),
    ...Object.keys(CompraVendaStatus).map((key) => ({
      value: (CompraVendaStatus as any)[key],
      label: operacaoStatusDescriptions[(CompraVendaStatus as any)[key]],
    })),
  ];

  useEffect(() => {
    getOperacoes();
  }, [getOperacoes]);

  const isUsuarioLeitura = useSelector((state: RootState) => state.auth.usuario.participante.perfil === Perfil.Leitura);

  const getStatusIcon = (status: string) => {
    switch (status) {
      case OperacaoCommonStatus.EmAnalise:
        return <Error fontSize="small" className={classes.waitingIcon} />;
      case CompraVendaStatus.Cancelada:
      case OperacaoCommonStatus.Reprovada:
        return <Cancel fontSize="small" className={classes.errorIcon} />;
      case OperacaoCommonStatus.Concluida:
        return <CheckCircle fontSize="small" className={classes.successIcon} />;
      case CompraVendaStatus.AguardandoLiquidacao:
        return <WatchLater fontSize="small" className={classes.warningIcon} />;
      case OfertaPrimariaStatus.AguardandoConfirmacao:
        return <ReportProblemOutlined fontSize="small" style={{ marginLeft: 10 }} />;
      default:
        return <></>;
    }
  };

  const getGridColumns = useCallback(
    () => [
      {
        field: 'STATUS',
        headerName: 'Status',
        type: 'singleSelect',
        valueOptions: statusValueOptions,
        filterOperators: filterOperatorsSelect,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 80,
        minWidth: 60,
        maxWidth: 100,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).status,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return (
            <Tooltip
              title={operacaoStatusDescriptions[item.status] ?? item.status}
              aria-label={operacaoStatusDescriptions[item.status]}
            >
              {getStatusIcon(item.status)}
            </Tooltip>
          );
        },
      },
      {
        field: 'DATA_DE_CRIACAO',
        headerName: 'Data de criação',
        type: 'date',
        filterOperators: filterOperatorsData,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 180,
        minWidth: 150,
        valueGetter: (params: GridValueGetterParams) => new Date((params.row as CompraVendaResumoResponse).dataCriacao),
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{formatDate(new Date(item.dataCriacao))}</Typography>;
        },
      },
      {
        field: 'TIPO',
        headerName: 'Ida/Volta',
        type: 'singleSelect',
        valueOptions: opcoesDeFiltroIdaOuVoltaDaCompromissada,
        filterOperators: filterOperatorsSelect,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 200,
        minWidth: 160,
        valueGetter: (params: GridValueGetterParams) =>
          descreverIdaOuVoltaDaCompromissada((params.row as CompraVendaResumoResponse).tipo),
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{descreverIdaOuVoltaDaCompromissada(item.tipo)}</Typography>;
        },
      },
      {
        field: 'CODIGO',
        headerName: 'Código',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 160,
        minWidth: 120,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).codigo,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.codigo}</Typography>;
        },
      },
      {
        field: 'RAZAO_SOCIAL_CUSTODIANTE_ORIGEM',
        headerName: 'Custodiante origem',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 220,
        minWidth: 180,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).custodianteOrigem,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.custodianteOrigem || '-'}</Typography>;
        },
      },
      {
        field: 'RAZAO_SOCIAL_CUSTODIANTE_DESTINO',
        headerName: 'Custodiante destino',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 220,
        minWidth: 180,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).custodianteDestino,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.custodianteDestino || '-'}</Typography>;
        },
      },
      {
        field: 'RAZAO_SOCIAL_INVESTIDOR_ORIGEM',
        headerName: 'Investidor origem',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 220,
        minWidth: 180,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).investidorOrigem,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.investidorOrigem}</Typography>;
        },
      },
      {
        field: 'RAZAO_SOCIAL_INVESTIDOR_DESTINO',
        headerName: 'Investidor destino',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 220,
        minWidth: 180,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).investidorDestino,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.investidorDestino}</Typography>;
        },
      },
      {
        field: 'RAZAO_SOCIAL_EMISSOR',
        headerName: 'Emissor',
        type: 'string',
        filterOperators,
        filterable: true,
        sortable: true,
        disableExport: false,
        width: 220,
        minWidth: 180,
        valueGetter: (params: GridValueGetterParams) => (params.row as CompraVendaResumoResponse).emissor,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return <Typography variant={'body2'}>{item.emissor}</Typography>;
        },
      },
      {
        field: 'HAS_DOCUMENT',
        headerName: 'Comprovantes',
        type: 'singleSelect',
        valueOptions: [
          { value: 'TRUE', label: 'Sim' },
          { value: 'FALSE', label: 'Não' },
        ],
        filterOperators: filterOperatorsSelect,
        filterable: true,
        sortable: true,
        disableExport: true,
        width: 120,
        minWidth: 100,
        maxWidth: 150,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;
          return item.hasComprovantes ? (
            <CheckCircle fontSize="small" className={classes.successIcon} />
          ) : (
            <Cancel fontSize="small" className={classes.errorIcon} />
          );
        },
      },
      {
        field: 'actions',
        headerName: ' ',
        filterable: false,
        sortable: false,
        disableExport: true,
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        renderCell: (params: GridCellParams) => {
          const item = params.row as CompraVendaResumoResponse;

          const podeAprovar = podeAprovarCompromissada(item, participanteId);
          const podeConfirmarLiquidacao = podeConfirmarLiquidacaoDaCompromissada(
            item,
            { id: participanteId, razaoSocial: participanteRazaoSocial },
            isUsuarioOperacoes
          );

          return (
            <MoreOptionsMenu>
              <MenuItem onClick={() => history.push(`/operacoes/gerenciar/compras-vendas/${item.operacaoId}`)}>
                <Description fontSize="small" style={{ marginRight: '10px' }} />
                {'Ver Detalhes'}
              </MenuItem>
              {podeAprovar && (
                <MenuItem onClick={() => handleOpenDrawer(DrawerAction.ACEITAR, item.operacaoId)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Aceitar'}
                </MenuItem>
              )}
              {podeAprovar && (
                <MenuItem onClick={() => handleOpenDrawer(DrawerAction.REJEITAR, item.operacaoId)}>
                  <Cancel fontSize="small" style={{ marginRight: '10px' }} />
                  {'Rejeitar'}
                </MenuItem>
              )}
              {podeConfirmarLiquidacao && (
                <MenuItem onClick={() => handleOpenDrawer(DrawerAction.CONFIRMAR_LIQUIDACAO, item.operacaoId)}>
                  <CheckCircle fontSize="small" style={{ marginRight: '10px' }} />
                  {'Confirmar Liquidação'}
                </MenuItem>
              )}
              {!isUsuarioLeitura && (
                <MenuItem onClick={() => handleOpenGestaoComprovantes(item)}>
                  <AttachFile fontSize="small" style={{ marginRight: '10px' }} />
                  {'Gestão de Comprovantes'}
                </MenuItem>
              )}
            </MoreOptionsMenu>
          );
        },
      },
    ],
    [
      filterOperators,
      filterOperatorsSelect,
      filterOperatorsData,
      statusValueOptions,
      history,
      participanteId,
      participanteRazaoSocial,
      isUsuarioOperacoes,
    ]
  );

  return (
    <>
      {showStatusToast && statusToastByAction(drawerAction)}
      <MdSpace />
      <LegendaStatus />
      <MdSpace />

      <div>
        <DataGridPro
          autoHeight
          localeText={localizedTextsMap}
          componentsProps={componentsPropsValues}
          getRowId={(row) => (row as CompraVendaResumoResponse).operacaoId}
          rows={operacoes}
          columns={getGridColumns()}
          pinnedColumns={{ right: ['actions'] }}
          components={{
            Toolbar: CustomToolBarUtils,
          }}
          disableSelectionOnClick
          rowsPerPageOptions={rowsPerPageOptionsValues}
          page={page}
          rowCount={pageCount}
          pagination
          paginationMode="server"
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          pageSize={pageSize}
          loading={showLoader}
          filterMode="server"
          onFilterModelChange={onFilterChange}
          sortingMode="server"
          onSortModelChange={onSortChange}
        />
        <GenericDrawer
          opened={openAprovarRejeitarDrawer}
          disableButtons={submitting}
          onClose={handleCloseDrawer}
          title={`${drawerAction === DrawerAction.ACEITAR ? 'Aceitar' : 'Rejeitar'} Movimentação`}
          textContents={[
            {
              text: `Tem certeza que deseja ${
                drawerAction === DrawerAction.ACEITAR ? 'aceitar' : 'rejeitar'
              } a movimentação por Compra e Venda referente ao instrumento financeiro ${
                operacao?.instrumentoFinanceiro.codigo ?? ''
              }?`,
            },
            { subtitle: 'Quantidade:', text: operacao?.compraVenda.quantidade.toString() },
            {
              subtitle: 'Preço Unitário:',
              text: formatEightDecimalsCurrency(operacao?.compraVenda.precoUnitario ?? 0),
            },
            {
              subtitle: 'Valor Total:',
              text: formatInstrumentoCurrency(
                (operacao?.compraVenda.quantidade ?? 0) * (operacao?.compraVenda.precoUnitario ?? 0),
                operacao?.instrumentoFinanceiro?.tipoInstrumentoFinanceiro
              ),
            },
            {
              subtitle: 'CPF/CNPJ do Comprador:',
              text: addCpfCnpjMask(operacao?.compraVenda.investidorDestino.cpfCnpj ?? ''),
            },
            {
              subtitle: 'Data de Retorno:',
              text: formatDate(operacao?.compraVenda.dataDeRetorno).toString() ?? '',
            },
            {
              subtitle: 'PU de Retorno:',
              text: formatEightDecimalsCurrency(operacao?.compraVenda.puDeRetorno ?? 0),
            },
            { subtitle: 'Conta Depósito do Comprador:', text: operacao?.compraVenda.investidorDestino.contaDeposito },
            { subtitle: 'Liquidação Direta:', text: operacao?.compraVenda.liquidacaoDireta ? 'Sim' : 'Não' },
          ]}
          buttons={[
            {
              buttonText: drawerAction === DrawerAction.ACEITAR ? 'Aceitar' : 'Rejeitar',
              buttonAction: drawerAction === DrawerAction.ACEITAR ? () => handleAceitar() : () => handleRejeitar(),
              buttonColor: drawerAction === DrawerAction.ACEITAR ? 'primary' : 'error',
            },
            {
              buttonText: 'Cancelar',
              buttonAction: () => handleCloseDrawer(),
            },
          ]}
        >
          {instrumentoInadimplido && (
            <>
              <Alert severity="error">
                {'Este Instrumento Financeiro está Inadimplido, ao continuar com a Movimentação você declara ciência.'}
              </Alert>
              <SmSpace />
            </>
          )}
        </GenericDrawer>

        <GenericDrawer
          opened={openConfirmarLiquidacaoDrawer}
          onClose={handleCloseDrawer}
          textContents={[
            {
              text: `Tem certeza que deseja confirmar a liquidação da movimentação por Compra e Venda referente ao instrumento financeiro ${
                operacao?.instrumentoFinanceiro?.codigo ?? 'não identificado'
              }?`,
            },
            { subtitle: 'Quantidade:', text: operacao?.compraVenda?.quantidade?.toString() ?? '' },
            ...(deveExibirPrecoUnitarioCalculado(operacao?.tipo)
              ? [
                  {
                    subtitle: 'Preço Unitário:',
                    text: formatEightDecimalsCurrency(operacao?.compraVenda?.precoUnitario ?? 0),
                  },
                ]
              : []),
            {
              subtitle: 'Valor Total:',
              text: formatInstrumentoCurrency(
                (operacao?.compraVenda.quantidade ?? 0) *
                  resolverPrecoUnitarioExibidoNaLiquidacao(
                    operacao?.tipo,
                    operacao?.compraVenda.precoUnitario,
                    precoUnitarioLiquidacao
                  ),
                operacao?.instrumentoFinanceiro?.tipoInstrumentoFinanceiro
              ),
            },
            {
              subtitle: 'CPF/CNPJ do Comprador:',
              text: safeGet(operacao, 'compraVenda.investidorDestino.cpfCnpj', '')
                ? addCpfCnpjMask(safeGet(operacao, 'compraVenda.investidorDestino.cpfCnpj', ''))
                : 'Não informado',
            },
            {
              subtitle: 'Conta Depósito do Comprador:',
              text: safeGet(operacao, 'compraVenda.investidorDestino.contaDeposito', 'Não informada'),
            },
            { subtitle: 'Liquidação Direta:', text: operacao?.compraVenda.liquidacaoDireta ? 'Sim' : 'Não' },
          ]}
          title={'Confirmar Liquidação'}
          buttons={[
            {
              buttonText: 'Confirmar Liquidação',
              buttonAction: () => handleConfirmarLiquidacao(),
              buttonColor: 'primary',
              buttonDisable: isRetornoCompromissada && precoUnitarioInformadoInvalido,
            },
            {
              buttonText: 'Cancelar',
              buttonAction: () => handleCloseDrawer(),
            },
          ]}
        >
          {isRetornoCompromissada && (
            <>
              <NumberField
                label={'Preço Unitário'}
                value={precoUnitarioLiquidacao}
                onChange={(value) => setPrecoUnitarioLiquidacao(value ?? undefined)}
                numberType="eightDecimals"
              />
              <SmSpace />
            </>
          )}
        </GenericDrawer>

        <GestaoComprovantesDrawer
          operacaoId={comprovantesOperacaoId}
          codigoInstrumento={comprovantesCodigoIF}
          comprovantes={compraVendaDocumentos}
          opened={openGestaoComprovantesDrawer}
          onClose={handleCloseGestaoComprovantes}
          onUploadSuccess={handleGestaoComprovantesUploadSuccess}
        />
      </div>
    </>
  );
};

export default ComprasVendasCompromissadas;
